import { authService } from '../auth/auth.service';
import config from '../config/config';
import store from '../store';
import endpoint from '../util/endpoint';
import { updateCartLoginTokens } from './cartLogin.action';
import { CartLoginToken } from '@whiz-cart/node-shared/models/account/cartLoginToken';

export default () => {
    const fetch = async () => {
        if (!authService.loginState.getState().isLoggedIn) return;

        try {
            const result = await endpoint('storeManager.cartTokens').get();
            const tokens = CartLoginToken.array().parse(result);
            store.dispatch(updateCartLoginTokens(tokens));
            console.debug(`Updated ${tokens.length} cart login tokens`);
        } catch (e) {
            console.warn('Failed to fetch cart login tokens:', e);
        }
    };

    let timer: ReturnType<typeof setInterval>;
    const cancelSubscribe = authService.loginState.subscribe(
        (state) => state.isLoggedIn,
        (isLoggedIn) => {
            clearInterval(timer);

            if (isLoggedIn) {
                fetch();
                timer = setInterval(fetch, config.cartLoginUpdateInterval);
            }
        },
    );

    return [() => clearInterval(timer), cancelSubscribe];
};
